<template>
  <div class="statements w3-border">
    <div class="w3-card" v-for="(statement) in convo.meta.statements">
      <p>
      <statement-view v-bind:statement="statement" v-bind:buttonType="buttonType" />
      </p>
    </div>
  </div>
</template>

<script>
  import ConvoStatements from "./ConvoStatements.ts";

  export default ConvoStatements;
</script>
